import React, { lazy, Suspense } from "react";
const Review = lazy(() => import("./studio/DesignReview"));
const Website = lazy(() => import("./website/Website"));
export default function App() {
  const path = window.location.pathname;
  return (
    <Suspense fallback={<p role="status">جارٍ تحميل ريفا…</p>}>
      {path.startsWith("/design-directions") ? (
        <Review slug={path.split("/")[2]} />
      ) : (
        <Website />
      )}
    </Suspense>
  );
}
